<template>
    <v-container fluid class="black">
        <footer-address v-if="!isCheckout" />
        <Links v-if="!isCheckout" />
        <copyright />
    </v-container>
</template>

<script>
    import Links from "./Links";
    import Address from "./Address";
    import Copyright from "./Copyright";

    export default {
        name: 'Footer',
        props: ['isCheckout'],
        components: {
            Copyright,
            Links,
            'FooterAddress': Address
        }
    }
</script>
